import React from 'react'
import { connect } from 'react-redux'
import Modal from 'react-modal'
import * as properties from '../../constants/Properties'
import { setCashRegistrationModal } from '../actions/modalActions'
import { setMessageModal } from '../../actions/generalActions'
import { getTranslation } from '../../actions/dataActions'
import { cashIn, cashOut } from '../../actions/receiptActions'
import { toggleKeyboard } from '../../actions/layoutActions'
import * as resource from '../../constants/Resources'

const CashRegistrationModal = props => {
  const {
    cashRegistrationModal,
    getTranslation,
    setCashRegistrationModal,
    setMessageModal,
    cashIn,
    cashOut,
    toggleKeyboard
  } = props;

  //const ref = useRef(); // do so when migrated to react 16.8
  
  const cancelTap = () => setCashRegistrationModal(false);

  const processTouchTap = () => {
    const {
      description,
      amount,
      isCashIn
    } = cashRegistrationModal;

    if (!description || description.trim() === "" || !amount || isNaN(amount) || isNaN(parseFloat(amount))) {     
      setMessageModal(true, getTranslation(resource.INPUT_EMPTY_MESSAGE));
      return;
    }

    if (isCashIn) {
      cashIn(description, amount);
    }
    else {
      cashOut(description, amount);
    }

    setCashRegistrationModal(false);
  }
  
  const updateAmount = e => {
    setCashRegistrationModal(
      cashRegistrationModal.show, 
      cashRegistrationModal.isCashIn, 
      cashRegistrationModal.description, 
      e
    );
  }

  const updateDescription = e => {
    setCashRegistrationModal(
      cashRegistrationModal.show, 
      cashRegistrationModal.isCashIn,
      e,
      cashRegistrationModal.amount
    );
  }

  const showKeyboardAmount = e => {
    toggleKeyboard(true, '#' + e.target.id, e.target.placeholder, updateAmount, [e.target.value]);
  }

  const showKeyboardDescription = e => {
    toggleKeyboard(true, '#' + e.target.id, e.target.placeholder, updateDescription, [e.target.value]);
  }

  const keyPressed = event => {
    if (event.key === "Enter") {
      switch(event.target.name)
      {
        case "description":
          break;
        case "amount":
          processTouchTap();
          break;
        default:
          break;
      }      
    }
  }

  return (
    <Modal className="cashRegistrationModal"
      contentLabel=""
      isOpen={cashRegistrationModal.show}
      style={properties.cashRegistrationModalStyle}
    >
      <div className="cashRegistrationModal_header">
          <div className="header_top">
          { cashRegistrationModal.isCashIn ? getTranslation(resource.CASH_IN_TITLE) : getTranslation(resource.CASH_OUT_TITLE) }
          </div>
      </div>
      <div className="cashRegistrationModal_content">
        <input
          className="cashRegistrationModal_input"
          type="text"
          name="description"
          id="cashdescription"
          placeholder={getTranslation(resource.DESCRIPTION)}
          onKeyPress={keyPressed}
          autoFocus={true}
          value={cashRegistrationModal.description}
          onClick={showKeyboardDescription} />
        <input
          className="cashRegistrationModal_input"
          type="text"
          name="amount"
          id="cashamount"
          placeholder={getTranslation(resource.AMOUNT)}
          onKeyPress={keyPressed}
          value={cashRegistrationModal.amount}
          onClick={showKeyboardAmount} />
      </div>
      <div className="cashRegistrationModal_footer">
        <button className="btnCancel" onClick={cancelTap} >
             {getTranslation(resource.CANCEL)}
          </button>
          <button className="btnApprove" onClick={processTouchTap} >
             {getTranslation(resource.SAVE)}
          </button>
      </div>
    </Modal>
  );
}

function mapStateToProps(state) {
  return {
    cashRegistrationModal: state.modalState.cashRegistrationModal,
  }
}

export default connect(mapStateToProps, { 
  setCashRegistrationModal,
  setMessageModal,
  getTranslation,
  cashIn,
  cashOut,
  toggleKeyboard
})(CashRegistrationModal)



// WEBPACK FOOTER //
// src/modal/components/CashRegistrationModal.jsx